"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
exports.initialState = {
    previewImage: '',
    selectedSkinTone: '',
    selectedSex: '',
    selectedPhenotype: '',
    isOnboarding: false,
};
